export enum DisciplineId {
    AllSports = '0',
    Favorites = 'favorites',
    Bonus = 'bonus',
}

export enum HomeTab {
    AllSports = 'all-sports',
}

export enum SportsMenuType {
    None = 'none',
    AllSports = 'allSports',
    TopSports = 'topSports',
    LiveSports = 'liveSports',
}